/* TrueBatch scroll-reveal — cards fade/slide in on first view.
   Progressive: without JS (or with reduced motion) everything is visible. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var targets = document.querySelectorAll('.tb-card, .tb-stat, .tb-stats-strip__item');
    var byParent = new Map();
    targets.forEach(function (el) {
      var parent = el.parentElement;
      var index = byParent.get(parent) || 0;
      byParent.set(parent, index + 1);
      el.style.setProperty('--tb-reveal-delay', Math.min(index * 60, 360) + 'ms');
      el.classList.add('tb-reveal');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tb-reveal--in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
